// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_1oy","cls2":"CreateSocialItemModal-cls2_DRO CreateSocialItemModal-cls1_1oy"};